import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../../components/ui/ToastContext";
import { jwtDecode } from 'jwt-decode';
import { AiOutlineDelete } from "react-icons/ai";
import { AiFillEdit } from "react-icons/ai";
import Select from 'react-select';
import { BsSearch } from "react-icons/bs";
import { API_URL } from "../../config";

function DashboardCard20() {
  const { showToast } = useToast();
  const location = useLocation();
  const { item: initialData } = location.state || {};  // Obținem datele din location.state
  const [selectedEditRowData, setSelectedEditRowData] = useState(initialData);
  const [selecteddeleteuser, setSelecteddeleteuser] = useState(null);
  const [data, setData] = useState([]);
  const [Manage1, setManage1] = useState([]);
  const [prod, setProd] = useState([]);
  const [selecteduser, setSelecteduser] = useState(null);
  const [selecteadres, setSelecteduadres] = useState(null);
  const [searchQuery1, setSearchQuery1] = useState('');
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [Manage, setManage] = useState([]);
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [showGrid, setShowGrid] = useState(true); // Stare pentru a controla ce să afișezi
  const [logError, setlogError] = useState(false);
  const [pasError, setpasError] = useState(false);
  const [defaultOption, setDefaultOption] = useState("");  // Default value should be role_id
  const [isLoading, setIsLoading] = useState(false);
  const [Nume_adres, setNume_adres] = useState("");
  const [filteredAdress, setFilteredAdress] = useState([]);
  const [isGroupAdresOpen, setIsGroupAdresOpen] = useState(false);
  const [nameError, setnameError] = useState(false);
  const [userData, setUserData] = useState([]);
  const [idadr, setIDadr] = useState("");
  const getJwtFromCookies = () => {
    const cookies = document.cookie.split("; ");
    const tokenCookie = cookies.find(row => row.startsWith("accessToken="));
    return tokenCookie ? tokenCookie.split("=")[1] : null;
  };
  //const token = getJwtFromCookies();

  const token = localStorage.getItem('jwtToken');


  useEffect(() => {
    axios
      .get(`${API_URL}/api/cities`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // ////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
        setProd(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/district`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // ////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
        setUserData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  // useEffect(() => {
  //   axios
  //     .get(`${API_URL}/api/adress`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //     })
  //     .then((response) => {
  //       // ////////////////////////////console.log("rrrrrrrrrrrrr", response.data);

  //       // Obține ultimul ID
  //       const lastAddress = response.data[response.data.length - 1];
  //       const lastAddressId = lastAddress ? lastAddress.adress_id : null;
  //       //  ////////////////////////console.log("Ultimul ID:", lastAddressId);
  //       setIDadr(lastAddressId);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(false); // După 1 secundă, comutăm pe grid
    }, 1000);

    // Cleanup pentru timer
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);  // decoded is the correct variable here
        setUser(decoded); // Store decoded user data
        //////////////////////////////console.log(user)
      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
  }, []);

  const fetchManageData = () => {
    axios
      .get(`${API_URL}/api/adressinstitutions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const users = response.data.filter(
          (item) => item.institution_id === selectedEditRowData?.institution_id
        );

        if (users.length > 0) {
          const subordinateUserId = users.map((item) => item.adress_id);

          axios
            .get(`${API_URL}/api/adress`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              const users = response.data.filter((item) =>
                subordinateUserId.includes(item.adress_id)
              );

              // ////console.log('Fetched users:', users);

              setData(users);
            })
            .catch((error) => {
              console.error("Error fetching users data:", error);
            });
        } else {
          setData([])
        }
      })
      .catch((error) => {
        console.error("Error fetching manage data:", error);
      });
  };

  useEffect(() => {
    ////////////////////////////console.log("useEffect triggered, data updated:", data);
    const selectProducerIds = data.map((item) => item.adress_id);
    const select = Manage1.filter((item) => !selectProducerIds.includes(item.adress_id));
    setManage(select);
  }, [data]); // Dependența 'data' trebuie să declanșeze acest efect

  useEffect(() => {
    axios
      .get(`${API_URL}/api/adress`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const uniqueManageData = response.data.reduce((acc, current) => {
          if (!acc.some(user => user.adress_id === current.adress_id)) {
            acc.push(current);
          }
          return acc;
        }, []);
        fetchManageData();

        setManage1(uniqueManageData);
      })
      .catch((error) => {
        console.error("Error fetching users data:", error);
      });
  }, [selectedEditRowData]);

  const uniqueUsers = data;
  // data.filter((user, index, self) =>
  //   index === self.findIndex((u) => u.adress_id === user.adress_id)
  // );

  const itemsPerPage = 15;
  const [currentPage, setCurrentPage] = useState(1);
  const total = uniqueUsers.filter((user) => user.description.toLowerCase().includes(searchQuery1.toLowerCase())
    || user.city_name.toLowerCase().includes(searchQuery1.toLowerCase())
    || user.district_name.toLowerCase().includes(searchQuery1.toLowerCase())
    || user.region_name.toLowerCase().includes(searchQuery1.toLowerCase())
  );
  const totalPages = Math.ceil(total.length / itemsPerPage);

  const currentItems = total.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const dropdownOptions = prod.map((role) => ({
    value: role.city_id,
    label: role.city_name,
    district_id: role.district_id,
  }));

  const _onSelect = (selectedOption) => {
    ////////////////////////////console.log(selectedOption);
    setDefaultOption(selectedOption);  // Set the selected option
  };

  useEffect(() => {
    if (selecteduser) {
      ////////////////////////////console.log("Selected user to delete:", selecteduser);  // Aici poți verifica ce conține userul selectat
      handleOpenProd1();
    }
  }, [selecteduser]);

  useEffect(() => {
    if (selecteadres) {
      ////////////////////////console.log("Selected :", selecteadres);  // Aici poți verifica ce conține userul selectat
      handleOpenProd2();
    }
  }, [selecteadres]);

  useEffect(() => {
    if (selecteddeleteuser) {
      ////////////////////////console.log(selecteddeleteuser)
      deleteRowuser();
    }
  }, [selecteddeleteuser]);

  const deleteRowuser = async () => {
    if (!selecteddeleteuser) return;
    //////////////////////////////console.log("delete user", selecteddeleteuser);

    try {
      await axios.put(
        `${API_URL}/api/deleteadressinstitutions`,
        {
          institution_id: selectedEditRowData.institution_id, adress_id: selecteddeleteuser.adress_id
        }
      );
      showToast({
        message: "Datele au fost sterse cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
      fetchManageData();
    } catch (error) {
      console.error("Error saving changes:", error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const handleOpenRows = () => {
    setOpen(true); // Deschide dialogul
  };

  const handleSave = async () => {

    ////////////////////////console.log(defaultOption)

    const filtered = Manage1.filter((address) =>
      address.description.toLowerCase() === Nume_adres.toLowerCase() && address.city_id === defaultOption
    );

    // ////////////////////////console.log(filtered.length)
    // ////////////////////////console.log(filtered[0]?.adress_id)

    try {
      // //////////////////////////////console.log("Selected Users:", selectedUsers);
      if (filtered.length === 1) {
        // ////////////////////////console.log("aici")
        await axios.post(`${API_URL}/api/adressinstitutions`, {
          institution_id: selectedEditRowData.institution_id,
          adress_id: filtered[0].adress_id
        });
      }
      else {
        // ////////////////////////console.log("adr noua");
        ////////////////////////////console.log(producerId.city_id);
        const response = await axios.post(`${API_URL}/api/adress`, {
          city_id: defaultOption,
          description: Nume_adres
        });

        const insertedAdressId = response.data.adress_id;
        // ////console.log("ID-ul adresei inserate:", insertedAdressId);

        await axios.post(`${API_URL}/api/adressinstitutions`, {
          institution_id: selectedEditRowData.institution_id,
          adress_id: insertedAdressId//idadr + 1
        });
      }

      setOpen(false);
      fetchManageData();
      showToast({
        message: "Datele au fost salvate cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
      setNume_adres("");
      setDefaultOption("");
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const handleEdit = async () => {
    // if (!Nume_prenume.trim()) {
    //   showToast({
    //     message: "Denumirea nu poate fi goală!",
    //     type: "error",
    //     icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
    //   });
    //   return;
    // }

    const filtered = Manage1.filter((address) =>
      address.description.toLowerCase() === Nume_adres.toLowerCase() && address.city_id === defaultOption
    );

    // ////////////////////////console.log(filtered[0].adress_id)

    try {
      if (filtered?.length === 1) {
        ////////////////////////console.log("aici")
        await axios.put(`${API_URL}/api/changeadressinstitutions/${selectedEditRowData?.institution_id}`,
          {
            adress_idold: selecteduser.adress_id,
            adress_id: filtered[0].adress_id
          });
      }
      else {
        ////////////////////////console.log("adr noua");
        //////////////////////////console.log(producerId.city_id);
        const response = await axios.post(`${API_URL}/api/adress`, {
          city_id: defaultOption,
          description: Nume_adres
        });

        const insertedAdressId = response.data.adress_id;
        // await axios.post(`${API_URL}/api/adress`, {
        //   city_id: defaultOption,
        //   description: Nume_adres
        // });

        await axios.put(`${API_URL}/api/changeadressinstitutions/${selectedEditRowData?.institution_id}`,
          {
            adress_idold: selecteduser.adress_id,
            adress_id: insertedAdressId//idadr + 1
          });

      }

      setOpen1(false);
      fetchManageData();

      showToast({
        message: "Datele au fost salvate cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const handleEditAdres = async () => {
    try {

      await axios.put(`${API_URL}/api/changeadress/${selecteadres?.adress_id}`,
        {
          description: Nume_adres
        });

      setNume_adres("");
      setOpen2(false);
      fetchManageData();

      showToast({
        message: "Datele au fost salvate cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const handleButtonClick = async () => {
    setIsLoading(true);
    try {
      await handleSave(); // Simulate the save operation
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false); // Re-enable the button after operation completes
    }
  };

  const handleChangea = (e) => {
    const value = e.target.value;
    setNume_adres(value);

    if (value) {
      // Filter addresses based on user input
      const filtered = Manage1.filter((address) =>
        address.description.toLowerCase().includes(value.toLowerCase()) && address.city_id === defaultOption
      );
      setIsGroupAdresOpen(true);
      setFilteredAdress(filtered);
    } else {
      setFilteredAdress([]);
      setIsGroupAdresOpen(false);
    }

    // Handle error for empty input
    if (!value) {
      setnameError(true);
    } else {
      setnameError(false);
    }
  };

  const handleSelectAddress = (address) => {
    setNume_adres(address.description);
    setIsGroupAdresOpen(false);

    setFilteredAdress([]); // Close the suggestions once an address is selected
  };

  const handleOpenProd1 = () => {
    ////////////////////////console.log(selecteduser);
    setOpen1(true); // Deschide dialogul
    setNume_adres(selecteduser.description);
    setDefaultOption(selecteduser.city_id)
  };

  const handleOpenProd2 = () => {
    ////////////////////////console.log(selecteadres);
    setOpen2(true); // Deschide dialogul
    setNume_adres(selecteadres.description);
    setDefaultOption(selecteadres.city_id)
  };

  const options = dropdownOptions.map((option) => {
    const district = userData.find((i) => i.district_id === option.district_id); // Găsim districtul corespunzător
    return {
      value: option.value,
      label: `${option.label} - ${district ? district.district_name : "N/A"}`, // Adăugăm informații suplimentare sau "N/A" dacă districtul nu există
    };
  });

  const isDarkMode = document.documentElement.classList.contains('dark');

  return (<div>
    {showGrid ? (
      <div className="flex flex-row gap-2">
        <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
        <div className="flex flex-col gap-2">
          <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
          <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
          <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
        </div>
      </div>
    ) : (
      <div className="col-span-full xl:col-span-8 bg-white dark:bg-gray-800 shadow-sm rounded-xl">
        <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 ">
          <div className="lg:flex lg:items-center lg:justify-between d-flex flex-column flex-md-row justify-content-between align-items-start">

            <h2 className="font-bold text-gray-800 dark:text-gray-100 mb-4 sm:mb-0 md:mb-0">Strazi</h2>
              <div className="sm:flex sm:items-center sm:gap-4 w-full sm:w-auto md:flex md:items-center md:gap-4 md:w-auto sm:flex-wrap">
                <div className="sm:flex sm:items-center sm:gap-4 w-full sm:w-auto md:flex md:items-center md:gap-4 md:w-auto">

                  <div className="relative w-full sm:w-64 md:w-64 ">
                    <BsSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <input
                      type="text"
                      className="pl-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 focus:border-blue-500 focus:outline-none dark:bg-gray-800 dark:text-gray-200 "
                      placeholder="Căutare"
                      value={searchQuery1}
                      onChange={(e) => setSearchQuery1(e.target.value)} />
                  </div>
                  {user?.role === "Admin" && (

                  <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white mt-4 sm:mt-0"
                    onClick={() => handleOpenRows()}
                  >
                    <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                      <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                    </svg>
                    <span className="//max-xs:sr-only">Adauga</span>

                    <Transition appear show={open} as={Fragment}>
                      <Dialog as="div" className="relative z-10" onClose={() => setOpen(false)}>
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0"
                          enterTo="opacity-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                        >
                          <div className="fixed inset-0 bg-black bg-opacity-25" />
                        </Transition.Child>

                        <div className="fixed inset-0 overflow-y-auto">
                          <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                              as={Fragment}
                              enter="ease-out duration-300"
                              enterFrom="opacity-0 scale-95"
                              enterTo="opacity-100 scale-100"
                              leave="ease-in duration-200"
                              leaveFrom="opacity-100 scale-100"
                              leaveTo="opacity-0 scale-95"
                            >
                              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                                <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                                  Adauga adresa
                                </Dialog.Title>
                                <div className="relative mt-4">
                                  <label className={`absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100 ${!defaultOption || defaultOption.length === 0 ? 'text-gray-300' : ''}`}>
                                    Adresa
                                  </label>
                                  <input
                                    className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100  ${logError ? 'border-red-500' : ''} ${!defaultOption || defaultOption.length === 0 ? 'border-gray-200' : ''}`}
                                    type="text"
                                    name="adresa"
                                    placeholder={!defaultOption || defaultOption.length === 0 ? "Alegeti initial orasul sau satul" : "Adresa"}
                                    value={Nume_adres}
                                    onChange={handleChangea}
                                    disabled={!defaultOption || defaultOption.length === 0}
                                  />
                                  {logError && <p className="text-red-500 text-sm">Adresa este obligatorie.</p>}

                                  {/* Display filtered address suggestions */}
                                  {filteredAdress && filteredAdress.length > 0 && (
                                    <div className="absolute top-full left-0 w-full mt-1 bg-white border rounded-md shadow-md max-h-48 overflow-auto z-10">
                                      {filteredAdress.map((address, index) => (
                                        <div
                                          key={index}
                                          className="p-2 cursor-pointer hover:bg-gray-200"
                                          onClick={() => handleSelectAddress(address)}
                                        >
                                          {address.description} {/* Afișează descrierea adresei */}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>

                                <div className="relative mt-4">
                                  {isGroupAdresOpen || (
                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100 z-10">
                                      Oras / sat
                                    </label>
                                  )}

                                  <Select
                                    options={options}
                                    defaultValue={options.find((opt) => opt.value === defaultOption)}
                                    onChange={(selectedOption) => _onSelect(selectedOption.value)}

                                    classNamePrefix="custom-select"
                                    isSearchable={true} // Permitem căutarea în select
                                    placeholder="Alege oras - sat"
                                    menuPortalTarget={document.body}
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        padding: '0.75rem',
                                        borderRadius: '0.375rem',
                                        borderColor: pasError ? 'red' : '#424242',
                                        boxShadow: 'none',
                                        color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                        backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                        zIndex: 0,
                                      }),
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999, // Z-index mare pentru a depăși dialogul
                                        color: isDarkMode ? 'black' : base.backgroundColor,
                                      }),
                                      singleValue: provided => ({
                                        ...provided,
                                        color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                      })
                                    }}
                                  />

                                </div>

                                <div className="mt-4 flex justify-end gap-2">
                                  <button
                                    className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                                    onClick={() => setOpen(false)}
                                  >
                                    Anulează
                                  </button>
                                  <button
                                    className={`btn ${isLoading
                                      ? "bg-gray-500 text-gray-300"
                                      : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
                                      }`}
                                    onClick={() => handleButtonClick()}
                                    disabled={isLoading}
                                  >
                                    {isLoading ? (
                                      <svg
                                        className="animate-spin fill-current shrink-0 xs:hidden"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                      >
                                        <circle
                                          className="opacity-25"
                                          cx="8"
                                          cy="8"
                                          r="7"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                        />
                                        <path
                                          className="opacity-75"
                                          d="M12 2a6 6 0 000 12V2z"
                                        />
                                      </svg>
                                    ) : (
                                      <svg
                                        className="fill-current shrink-0 xs:hidden"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                      </svg>
                                    )}
                                    <span className="//max-xs:sr-only">
                                      {isLoading ? "Saving..." : "Salveaza detaliile"}
                                    </span>
                                  </button>
                                </div>
                              </Dialog.Panel>
                            </Transition.Child>
                          </div>
                        </div>
                      </Dialog>
                    </Transition>
                  </button>
                  )}
                </div>
              </div>
           
            <Transition appear show={open1} as={Fragment}>
              <Dialog as="div" className="relative z-10" onClose={() => setOpen1(false)}>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                  <div className="flex min-h-full items-center justify-center p-4 text-center">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0 scale-95"
                      enterTo="opacity-100 scale-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100 scale-100"
                      leaveTo="opacity-0 scale-95"
                    >
                      <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                        <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                          Editeaza adresa
                        </Dialog.Title>
                        <div className="relative mt-4">
                          <label className={`absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100`}>
                            Adresa
                          </label>
                          <input
                            className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100  ${logError ? 'border-red-500' : ''} `}
                            type="text"
                            name="adresa"
                            placeholder={"Adresa"}
                            value={Nume_adres}
                            onChange={handleChangea}
                          />
                          {logError && <p className="text-red-500 text-sm">Adresa este obligatorie.</p>}

                          {filteredAdress && filteredAdress.length > 0 && (
                            <div className="absolute top-full left-0 w-full mt-1 bg-white border rounded-md shadow-md max-h-48 overflow-auto z-10">
                              {filteredAdress.map((address, index) => (
                                <div
                                  key={index}
                                  className="p-2 cursor-pointer hover:bg-gray-200"
                                  onClick={() => handleSelectAddress(address)}
                                >
                                  {address.description}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        <div className="relative mt-4">
                          {isGroupAdresOpen || (
                            <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100 z-10">
                              Oras / sat
                            </label>
                          )}

                          <Select
                            options={options}
                            defaultValue={options.find((opt) => opt.value === defaultOption)}
                            onChange={(selectedOption) => _onSelect(selectedOption.value)}

                            classNamePrefix="custom-select"
                            isSearchable={true} // Permitem căutarea în select
                            placeholder="Alege oras - sat"
                            menuPortalTarget={document.body}
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                width: '100%',
                                padding: '0.75rem',
                                borderRadius: '0.375rem',
                                borderColor: pasError ? 'red' : '#424242',
                                boxShadow: 'none',
                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                zIndex: 0,
                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999, // Z-index mare pentru a depăși dialogul
                                color: isDarkMode ? 'black' : base.backgroundColor,
                              }),
                              singleValue: provided => ({
                                ...provided,
                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                              })
                            }}
                          />

                        </div>

                        <div className="mt-4 flex justify-end gap-2">
                          <button
                            className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                            onClick={() => setOpen1(false)}
                          >
                            Anulează
                          </button>
                          <button
                            className="px-4 py-2 rounded bg-gray-800 text-white hover:bg-gray-900 dark:bg-gray-200 dark:text-gray-700"
                            onClick={() => handleEdit()}
                          >
                            Salvează
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition>

            <Transition appear show={open2} as={Fragment}>
              <Dialog as="div" className="relative z-10" onClose={() => setOpen2(false)}>
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="fixed inset-0 bg-black bg-opacity-25" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                  <div className="flex min-h-full items-center justify-center p-4 text-center">
                    <Transition.Child
                      as={Fragment}
                      enter="ease-out duration-300"
                      enterFrom="opacity-0 scale-95"
                      enterTo="opacity-100 scale-100"
                      leave="ease-in duration-200"
                      leaveFrom="opacity-100 scale-100"
                      leaveTo="opacity-0 scale-95"
                    >
                      <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all dark:bg-gray-800">
                        <Dialog.Title as="h3" className="text-lg font-bold leading-6 text-gray-900  dark:text-gray-200">
                          Editeaza adresa
                        </Dialog.Title>
                        <div className="relative mt-4">
                          <label className={`absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100`}>
                            Adresa
                          </label>
                          <input
                            className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100  ${logError ? 'border-red-500' : ''} `}
                            type="text"
                            name="adresa"
                            placeholder={"Adresa"}
                            value={Nume_adres}
                            onChange={handleChangea}
                          />
                          {logError && <p className="text-red-500 text-sm">Adresa este obligatorie.</p>}

                          {filteredAdress && filteredAdress.length > 0 && (
                            <div className="absolute top-full left-0 w-full mt-1 bg-white border rounded-md shadow-md max-h-48 overflow-auto z-10">
                              {filteredAdress.map((address, index) => (
                                <div
                                  key={index}
                                  className="p-2 cursor-pointer hover:bg-gray-200"
                                  onClick={() => handleSelectAddress(address)}
                                >
                                  {address.description}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>



                        <div className="mt-4 flex justify-end gap-2">
                          <button
                            className="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200"
                            onClick={() => setOpen2(false)}
                          >
                            Anulează
                          </button>
                          <button
                            className="px-4 py-2 rounded bg-gray-800 text-white hover:bg-gray-900 dark:bg-gray-200 dark:text-gray-700"
                            onClick={() => handleEditAdres()}
                          >
                            Salvează
                          </button>
                        </div>
                      </Dialog.Panel>
                    </Transition.Child>
                  </div>
                </div>
              </Dialog>
            </Transition>
          </div>
        </header>
        {
          uniqueUsers.length > 0 ? (

            <div className="p-3" >
              {/* Table */}
              <div className="overflow-x-auto">
                <table className="table-auto w-full dark:text-gray-300">
                  {/* Table header */}
                  <thead className="text-xs uppercase text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                    <tr>
                      <th className="p-2">
                        <div className="font-semibold text-left">Adresa</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-center">Oras / sat</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-center">Raion</div>
                      </th>
                      <th className="p-2">
                        <div className="font-semibold text-center">Regiunea</div>
                      </th>

                      <th className="p-2">
                      <div className={`font-semibold text-center ${user.role !== "Admin" ? "hidden" : ""}`}>                          Actiune</div>
                      </th>
                    </tr>
                  </thead>
                  {/* Table body */}
                  <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                    {currentItems.map((customer, index) => {
                      return (
                        <tr
                          key={customer.adress_id}
                          className={`${index % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"
                            } hover:bg-gray-200 dark:hover:bg-gray-600`}
                        >
                          <td className="p-2 whitespace-nowrap">
                            <div className="text-left">{customer.description}
                              {user && user.role === 'Admin' && (

                                <IconButton
                                  onClick={() => setSelecteduadres(customer)}
                                  color="primary"
                                  sx={{
                                    fontSize: "16px",
                                    borderRadius: "50%",
                                    "&:hover": {
                                      backgroundColor: "#a4adad",
                                    },
                                  }}
                                >

                                  <AiFillEdit className=" dark:text-gray-100" />
                                </IconButton>
                              )}
                            </div>
                          </td>
                          <td className="p-2 whitespace-nowrap">
                            <div className="text-center">{customer.city_name}</div>
                          </td>
                          <td className="p-2 whitespace-nowrap">
                            <div className="text-center">{customer.district_name}</div>
                          </td>
                          <td className="p-2 whitespace-nowrap">
                            <div className="text-center">{customer.region_name}</div>
                          </td>
                          <td>
                          <div className={`font-semibold text-center ${user.role !== "Admin" ? "hidden" : ""}`}                            style={{
                                fontWeight: "bold",
                                fontSize: "20px"
                              }}
                            >
                              <IconButton
                                onClick={() => setSelecteduser(customer)}
                                color="primary"
                                sx={{
                                  fontSize: "16px",
                                  borderRadius: "50%",
                                  "&:hover": {
                                    backgroundColor: "#a4adad",
                                  },
                                }}
                              >
                                <AiFillEdit className=" dark:text-gray-100" />
                              </IconButton>

                              <IconButton
                                onClick={() => setSelecteddeleteuser(customer)}
                                color="primary"
                                sx={{
                                  fontSize: "16px",
                                  borderRadius: "50%",
                                  "&:hover": {
                                    backgroundColor: "#a4adad",
                                  },
                                }}
                              >
                                <AiOutlineDelete className=" dark:text-gray-100" />
                              </IconButton>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {uniqueUsers.length > 5 && (
                <div className="flex justify-center mt-4">
                  <button
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                    disabled={currentPage === 1}
                  >
                    Prev
                  </button>

                  {currentPage > 3 && (
                    <>
                      <button
                        onClick={() => setCurrentPage(1)}
                        className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                      >
                        1
                      </button>
                      <span className="px-2">...</span>
                    </>
                  )}

                  {Array.from({ length: totalPages }, (_, index) => {
                    const page = index + 1;

                    if (
                      page === currentPage ||
                      // page === 1 ||
                      // page === totalPages ||
                      (page >= currentPage - 2 && page <= currentPage + 2)
                    ) {
                      return (
                        <button
                          key={page}
                          onClick={() => setCurrentPage(page)}
                          className={`px-4 py-2 text-sm font-medium ${currentPage === page
                            ? "bg-gray-500 text-white"
                            : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                            }`}
                        >
                          {page}
                        </button>
                      );
                    }
                    return null;
                  })}

                  {currentPage < totalPages - 2 && (
                    <>
                      <span className="px-2">...</span>
                      <button
                        onClick={() => setCurrentPage(totalPages)}
                        className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                      >
                        {totalPages}
                      </button>
                    </>
                  )}

                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          ) : (<h2 className="px-5 py-4 text-gray-600 dark:text-gray-400 ">Nou exista date concrete</h2>
          )
        }
      </div >
    )
    }</div >
  );
}

export default DashboardCard20;
